// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Raa-z","narrowOptionButtons":"Saa-z","noOptions":"Taa-z"};